import { UserFavorite, UserPackage } from "src/models";
import { ProfileData, ProfileDataInitialState, ReduxAction } from "../models";
import { ModalsType, ProfileDataTypes } from "../types";
import { UserSessionTypes } from "../types/user.session.types";

export const ProfileDataState = (state: ProfileData = ProfileDataInitialState, action?: ReduxAction): ProfileData => {
    if (!action) return state;

    switch (action.type) {
        case UserSessionTypes.LOGOUT_USER:
        case UserSessionTypes.CLEAR_LOGIN_INFO:
        case UserSessionTypes.REQUEST_USER_INFO:
            return {
                ...state,
                packageSummaries: { ...ProfileDataInitialState.packageSummaries },
                packages: { ...ProfileDataInitialState.packages },
                devices: { ...ProfileDataInitialState.devices },
                deviceToTerminate: { ...ProfileDataInitialState.deviceToTerminate },
                favorites: { ...ProfileDataInitialState.favorites }
            };
        case ProfileDataTypes.REQUEST_PACKAGE_SUMMARIES:
            return {
                ...state, packageSummaries: {
                    ...state.packageSummaries,
                    loading: true,
                }
            };

        case ProfileDataTypes.SET_PACKAGE_SUMMARIES:
            return {
                ...state, packageSummaries: {
                    firstLoad: false,
                    loading: false,
                    packages: action.payload.packages,
                    sitePackages: action.payload.sitePackages
                }
            };

        case ProfileDataTypes.SHOW_USER_PACKAGES_LOADING:
        case ProfileDataTypes.REQUEST_LOAD_USER_PACKAGES:
            return { ...state, packages: { ...state.packages, loading: true, list: action.payload?.offset ? state.packages.list : [] } };
        case ProfileDataTypes.HIDE_USER_PACKAGES_LOADING:
            return { ...state, packages: { ...state.packages, loading: false } };
        case ProfileDataTypes.SET_USER_PACKAGES_DATA:
            const data: { list: UserPackage[], count: number, totalRecords?: number } = action.payload;

            let list = [...state.packages.list, ...data.list];

            const offset = state.packages.offset + (data.list.length > 0 ? data.count : 0);

            return {
                ...state,
                packages: {
                    ...state.packages,
                    list,
                    offset: offset === 0 ? -1 : offset,
                    count: data.count,
                    totalRecords: data.totalRecords === undefined ? state.packages.totalRecords : data.totalRecords,
                    loading: false,
                    firstLoad: false,
                }
            };

        case ProfileDataTypes.GET_USER_DEVICES:
            return {
                ...state,
                devices: {
                    ...state.devices, loading: true,
                    page: action.payload || ProfileDataInitialState.devices.page,
                }
            };
        case ProfileDataTypes.SET_USER_DEVICES:
            return {
                ...state,
                devices: {
                    firstLoad: false,
                    list: action.payload?.list || [],
                    loading: false,
                    page: action.payload?.page || state.devices.page || ProfileDataInitialState.devices.page,
                    pages: action.payload?.pages || state.devices.pages || ProfileDataInitialState.devices.pages
                }
            };
        case ProfileDataTypes.REQUEST_ACCESS_CODE:
            return {
                ...state,
                deviceToTerminate: {
                    currentDevice: action.payload?.currentDevice,
                    onSuccessCallback: action.payload?.onSuccess,
                    sendingSms: true,
                    seningRequest: false,
                    message: "",
                    phone: "",
                    seconds: -1
                }
            };
        case ProfileDataTypes.CONNECT_CURRENT_DEVICE_CONFIRM_CODE:
        case ProfileDataTypes.CUT_ALL_DEVICE_CONFIRM_CODE:
            return {
                ...state,
                deviceToTerminate: {
                    ...state.deviceToTerminate,
                    seningRequest: true
                }
            };
        case ProfileDataTypes.ACCESS_NOT_TOGGLED:
            return {
                ...state,
                deviceToTerminate: {
                    ...state.deviceToTerminate,
                    seningRequest: false
                }
            };
        case ProfileDataTypes.ACCESS_TOGGLED:
            return {
                ...state,
                devices: {
                    ...state.devices,
                    list: [...state.devices.list.map((x) => ({
                        ...x,
                        hasAccess: x.current ? true : (action.payload ? x.hasAccess : false)
                    }))]
                }
            };
        case ProfileDataTypes.CLEAR_ACCESS_CODE_INFO:
            return {
                ...state,
                deviceToTerminate: { ...ProfileDataInitialState.deviceToTerminate }
            };
        case ProfileDataTypes.ACCESS_CODE_SENT:
            return {
                ...state,
                deviceToTerminate: {
                    ...state.deviceToTerminate,
                    ...action.payload,
                    sendingSms: false,
                }
            };

        case ProfileDataTypes.REQUEST_USER_FAVORITES:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    list: action.payload ? [] : state.favorites.list,
                    loading: true
                }
            };

        case ProfileDataTypes.SET_USER_FAVORITES:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    loading: false,
                    list: action.payload || [],
                    editingFavorite: (action.payload || []).find((x: UserFavorite) => x.title === state.favorites.editingFavorite?.title)
                }
            };

        case ProfileDataTypes.SEARCH_FOR_FAVORITES:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    searchLoading: true
                }
            };

        case ProfileDataTypes.SET_FAVORITES_SEARCH_RESULT:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    searchLoading: false,
                    searchItems: action.payload || [],
                }
            };

        case ProfileDataTypes.ADD_FAVORITE_ITEM:
        case ProfileDataTypes.REMOVE_FAVORITE_ITEM:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    actionLoading: true
                }
            };
        case ProfileDataTypes.CLEAR_FAVORITE_ACTION_LOADING:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    actionLoading: false
                }
            };
        case ModalsType.SHOW_FAVORITE_MODAL:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    editingFavorite: action.payload
                }
            };
        case ModalsType.HIDE_FAVORITE_MODAL:
            return {
                ...state,
                favorites: {
                    ...state.favorites,
                    editingFavorite: undefined,
                    searchItems: [],
                    searchLoading: false,
                }
            };
    }

    return state;
};